"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const TableHead_1 = __importDefault(require("@mui/material/TableHead"));
const TableCell_1 = __importDefault(require("@mui/material/TableCell"));
const TableRow_1 = __importDefault(require("@mui/material/TableRow"));
const Checkbox_1 = __importDefault(require("@mui/material/Checkbox"));
const TableHeader = (props) => {
    const { classes, columns, selectedAccounts, totalRows, onChangeAccountsToShow } = props;
    const isIndeterminate = (0, react_1.useMemo)(() => selectedAccounts > 0 && selectedAccounts < totalRows, [totalRows, selectedAccounts]);
    const isChecked = (0, react_1.useMemo)(() => totalRows > 0 && selectedAccounts === totalRows, [totalRows, selectedAccounts]);
    const onChange = (0, react_1.useCallback)(() => onChangeAccountsToShow(isChecked ? 'CLEAR' : 'ALL'), [onChangeAccountsToShow, isChecked]);
    return (<TableHead_1.default>
      <TableRow_1.default>
        {Object.keys(columns).map((key) => {
            var _a;
            const column = columns[key];
            return (<TableCell_1.default key={key} className={(0, classnames_1.default)(props.classes.resetCell, (_a = props.classes) === null || _a === void 0 ? void 0 : _a[key])}>
              <div className={classes === null || classes === void 0 ? void 0 : classes[`${key}Container`]}>
                {column.label ? column.label : (<Checkbox_1.default color="default" indeterminate={isIndeterminate} checked={isChecked} onChange={onChange}/>)}
              </div>
            </TableCell_1.default>);
        })}
      </TableRow_1.default>
    </TableHead_1.default>);
};
exports.default = react_1.default.memo(TableHeader);
